<template>
  <el-dialog :visible.sync="dialogVisible" @open="dialogOpen"     customClass="customWidth">
    <div slot="title">维护
      <el-tag>{{role.roleName}}</el-tag>用户</div>
    <el-form :inline="true" :model="searchForm" ref="searchForm" size="mini" style="margin-bottom: -18px;">
      <el-form-item label="名称" prop="userName">
        <el-input v-model="searchForm.userName" placeholder="名称" style="width: 100px;" />
      </el-form-item>

      <el-form-item label="手机号码" prop="email">
        <el-input v-model="searchForm.email" placeholder="手机号码" style="width: 120px;" />
      </el-form-item>
      <el-form-item>
        <el-select
                class="filter-item"
                v-model="searchForm.dl_type22"
                placeholder="用户类型"
                width="50"
        >
          <el-option
                  v-for="item in typeOptions"
                  :key="item.value"
                  :label="item.label"
                  :value="item.value"
          ></el-option>
        </el-select>
      </el-form-item>
      <el-form-item>
        <el-button type="primary" @click="handleSearchFormSubmit">
          <d2-icon name="search" /> 查询
        </el-button>
      </el-form-item>

      <el-form-item>
        <el-button @click="handleSearchFormReset">
          <d2-icon name="refresh" /> 重置
        </el-button>
      </el-form-item>
    </el-form>

    <el-table :data="tableData" v-loading="loading" size="small" stripe highlight-current-row style="width: 100%;" @sort-change="handleSortChange">
      <el-table-column label="账号名称" prop="userCode">
        <template slot-scope="scope">
          {{scope.row.userCode}}
        </template>
      </el-table-column>
      <el-table-column label="用户名称" prop="userName">
        <template slot-scope="scope">
          {{scope.row.userName}}
        </template>
      </el-table-column>
      <el-table-column label="用户类型" prop="userName">
        <template slot-scope="scope">
          <div v-if="scope.row.dl_type=='-1'">
            OEM方
          </div>
          <div v-else-if="scope.row.dl_type=='0'">
            一级代理
          </div>
          <div v-else-if="scope.row.dl_type=='1'">
            二级代理
          </div>
          <div v-else-if="scope.row.dl_type=='2'">
            三级代理
          </div>
          <div v-else-if="scope.row.dl_type=='4'">
            商家
          </div>



        </template>
      </el-table-column>
      <el-table-column label="邮箱" prop="email" sortable="custom" :show-overflow-tooltip="true">
        <template slot-scope="scope">
          {{scope.row.email}}
        </template>
      </el-table-column>
      <el-table-column label="phone" prop="mobileNo">
        <template slot-scope="scope">
          {{scope.row.mobileNo}}
        </template>
      </el-table-column>
      <el-table-column fixed="right" label="操作" align="center">
        <template slot-scope="scope">
          <el-button v-if="scope.row.isAdd==0" type="primary" title="添加" size="mini" icon="el-icon-plus" circle @click="modifyRoleUser(scope.row.userId,1)"></el-button>
          <el-button  v-if="scope.row.isAdd==1"  type="danger" title="移除" size="mini" icon="el-icon-minus" circle @click="modifyRoleUser(scope.row.userId,0)"></el-button>
        </template>
      </el-table-column>

    </el-table>
    <div slot="footer">
      <el-pagination :current-page="page.current" :page-size="page.size" :total="page.total" :page-sizes="[1,10,50,100, 200, 300, 400]" layout="total, sizes, prev, pager, next, jumper" style="margin: -10px;" @size-change="handleSizeChange" @current-change="handleCurrentChange">
      </el-pagination>
    </div>
  </el-dialog>
</template>
<style>
  .customWidth{
    width:60%;
  }
</style>
<script>
import * as userService from "@/api/sys/user";
import util from '@/libs/util.js'
export default {
  name: "roleUser",
  props: {
    role: Object,
    value: Boolean
  },
  data() {
    return {
      dialogVisible: false,
      searchForm: {
          userName: "",
          dl_type22: "",
        email: ""
      },
      loading: false,
      tableData: [],
        typeOptions: [
            {
                value: "0",
                label: "一级代理"
            },
            {
                value: "1",
                label: "二级代理"
            },
            {
                value: "2",
                label: "三级代理"
            },
            {
                value: "4",
                label: "商家"
            }
        ],
      page: {
        current: 1,
        size: 10,
        total: 0
      },
      sort: {
        prop: "",
        order: ""
      }
    };
  },
  watch: {
    value(val) {
      this.dialogVisible = val;
    },
    dialogVisible(val) {
      this.$emit("input", val);
    }
  },
  methods: {
    async dialogOpen() {
      this.getTableData();
    },
    getTableData() {
        console.log("=========roleId:"+this.role.roleId);
      let query = {
        pageIndex: this.page.current,
        pageSize: this.page.size,
        sortBy: this.sort.prop,
        descending: this.sort.order === "descending",
          agentid:util.cookies.get('agentid'),
          xt_id:util.cookies.get('xt_id'),
          dl_type:util.cookies.get('dl_type'),
        filter: { ...this.searchForm, roleId: this.role.roleId }
      };
      userService.getUserPagedList(query).then(data => {
        this.tableData = data.rows;
        this.page.total = data.totalCount;
      });
    },
    handleSearchFormSubmit() {
        this.page.current=1;
      this.getTableData();
    },
    handleSearchFormReset() {
      this.$refs.searchForm.resetFields();
    },
    handleSortChange(val) {
      this.sort.prop = val.prop;
      this.sort.order = val.order;
      this.getTableData();
    },
    handleSizeChange(val) {
      this.page.size = val;
      this.getTableData();
    },
    handleCurrentChange(val) {
      this.page.current = val;
      this.getTableData();
    },
    modifyRoleUser(userId, action) {
      userService
        .editRoleUser({
          roleId: this.role.roleId,
          userId: userId,
          action: action
        })
        .then(() => {
          let msg = action == 1 ? "已添加" : "已移除";
          this.$notify({
            title: "操作成功",
            message: msg,
            type: "success"
          });
          this.getTableData();
        });
    }
  }
};
</script>

